import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AhEtoGif from '../images/others/ah-eto-bleh.gif'

class Error extends Component {
  render() {
    return (
    <div className='error-page'>
        <img src={AhEtoGif} alt="Funny gif"  width="250" />
        <h1>Hey ! Looks like you got lost !</h1>
        <Link className='error-backbutton' to="/">Back to Home page</Link>
    </div>
    );
  }
}

export default Error;